import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FileUploaderModule } from '../../chords/file-upload/file-uploader.module';
import { FormGroupModule } from '../../chords/form-group/form-group.module';
import { AccordionModule } from '../../notes/accordion/accordion.module';
import { ButtonModule } from '../../notes/button/button.module';
import { CardModule } from '../../notes/card/card.module';
import { IconModule } from '../../notes/icon/icon.module';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';
import { PreloaderModule } from '../../notes/preloader/preloader.module';
import { SimpleCardModule } from '../../notes/simple-card/simple-card.module';
import { TabsModule } from '../../notes/tabs/tabs.module';
import { ClaimSubmissionFooterComponent } from './claim-submission-footer/claim-submission-footer.component';
import { ClaimSubmissionFormsComponent } from './claim-submission-forms/claim-submission-forms.component';
import { ClaimSubmissionInstructionsComponent } from './claim-submission-instructions/claim-submission-instructions.component';
import { ClaimSubmissionReviewComponent } from './claim-submission-review/claim-submission-review.component';
import { ClaimSubmissionSummaryComponent } from './claim-submission-summary/claim-submission-summary.component';
import { ClaimSubmissionComponent } from './claim-submission.component';
import { ClaimItemsInformationReviewComponent } from './components/claim-items-information-review/claim-items-information-review.component';
import { ClaimLineInfoReviewComponent } from './components/claim-line-info-review/claim-line-info-review.component';
import { SupportingDocumentationReviewComponent } from './components/supporting-documentation-review/supporting-documentation-review.component';
import { SupportingDocumentationComponent } from './components/supporting-documentation/supporting-documentation.component';
import { TotalProviderChargesReviewComponent } from './components/total-provider-charges-review/total-provider-charges-review.component';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';

@NgModule({
  declarations: [
    ClaimSubmissionFormsComponent,
    ClaimSubmissionInstructionsComponent,
    SupportingDocumentationComponent,
    ClaimSubmissionComponent,
    ConfirmationPageComponent,
    ClaimSubmissionReviewComponent,
    ClaimLineInfoReviewComponent,
    SupportingDocumentationReviewComponent,
    TotalProviderChargesReviewComponent,
    ClaimSubmissionFooterComponent,
    ClaimItemsInformationReviewComponent,
    ClaimSubmissionSummaryComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormGroupModule,
    TabsModule,
    AccordionModule,
    ButtonModule,
    IconModule,
    FileUploaderModule,
    CardModule,
    MessageBannerModule,
    PreloaderModule,
    ModelAttributeModule,
    RouterModule,
    SimpleCardModule,
  ],
  exports: [ClaimSubmissionComponent],
})
export class ClaimSubmissionModule {}
